import { api } from "./api";


api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token'); // Or AsyncStorage for mobile
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


export const StudentList = async (addUrl) => {
  let url = `student/fees/deposit/data?${addUrl}`;
  return await api.get(url);
};
export const feeDepositList = async (addUrl) => {
  let url = `student/fees/deposit/list?${addUrl}`;
  return await api.get(url);
};

export const feeDepositListV4 = async (addUrl) => {
  return await api.get(`student/fees/deposit/list/v4?${addUrl}`);
};

export const studentDueFees = async (addUrl) => {
  let url = `/month/due/fees/batch/wise?${addUrl}`;
  return await api.get(url);
};

export const studentDueFeesV4 = async (addUrl) => {
  return await api.get(`/month/due/fees/batch/wise/v4?${addUrl}`);
};

export const studentRegPending = async (addUrl) => {
  let url = `/registration/fees/pending/list?${addUrl}`;
  return await api.get(url);
};

export const studentRegPendingV4 = async (addUrl) => {
  return await api.get(`/registration/fees/pending/list/v4?${addUrl}`);
};


export const feesdeposite = async (data) => {
  return await api.post('student/fee_deposit', data); // ✅ correct endpoint, NO /:id
};
export const feesdeposites = async (data) => {
  return await api.post('student/fee_deposit/v4', data); // ✅ correct endpoint, NO /:id
};

export const feesfollowup = async (data) => {
  return await api.post('student/fees/followup', data)
}

export const feesResponsePost = async (data) => {
  return await api.post(`/calling/response/post`, data)
}

export const feesResponseFetch = async (addUrl = '') => {
  let url = `/calling/response/list?${addUrl}`;
  return await api.get(url)
}

export const feesReportDashboard = async (addUrl = '') => {
  let url = `/fees/report/dashboard?${addUrl}`;
  return await api.get(url)
}